import React from 'react'

// API
import { Grid } from '@material-ui/core'
import { PageTabs } from '../../components/ui/PageTabs'
import moment from 'moment'
import { motion } from "framer-motion";

// Base Page
import BasePage from '../basePage'

// Molecules
import {
  RelatorioAgenda,
  RelatorioNotas,
  Downloads,
} from '../../components/molecules'

// Material.ui

// moment
import 'moment/locale/pt-br'
import { useLocation } from 'react-router-dom'

moment.locale('pt-br')

// import Relatorio from '../components/organisms/Relatorio'
import { ReportProvider } from '../../providers/report'
import { RoyaltyStatement } from './RoyaltyStatement'
import { PurchaseReport } from './PurchaseReport'
import { CustomersReport } from './CustomersReport'
import { PetsReport } from './PetsReport'
import { PackagesReport } from './PackagesReport'
import { DispatchReport } from './DispatchReport'
import { useQueryParam } from 'use-query-params'
import { useMenu } from '../../store/global/useMenu';
import { ChartNoAxesCombined } from 'lucide-react';

function RelatorioPage() {
  const [tab, setTap] = useQueryParam("tab");

  const menuSize = useMenu(st => st.data.size)


  const initialTab = !tab || tab === "agendamentos"

  const date = new Date()
  const primeiroDia = moment(
    new Date(date.getFullYear(), date.getMonth(), 1),
  ).format('YYYY-MM-DD')

  return (
    <ReportProvider>
      <BasePage pageTitle={<><ChartNoAxesCombined className='w-7 h-7' />Relatórios</>}>
        <motion.div className='flex flex-col pt-1.5 pr-4' initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          transition={{ duration: 0.3 }}>
          <PageTabs
            ariaLabel="Relatórios"
            value={tab || "agendamentos"}
            onChange={(value) => setTap(value)}
            style={{
              boxShadow: '0 6px 20px rgb(0 0 0 / 10%)',
              borderRadius: '7px 7px 0 0',
              background: '#fff',
            }}
            tabs={[
              { value: "agendamentos", label: "Agendamentos" },
              { value: "clientes", label: "Clientes" },
              { value: "pets", label: "Pets" },
              { value: "pacotes", label: "Pacotes" },
              { value: "disparos", label: "Disparos" },
              { value: "compras", label: "Compras" },
              { value: "minhas-exportacoes", label: "Minhas exportações" },
            ]}
          />

          {tab === "royalty-statement" && (
            <Grid container spacing={3} style={{ flex: 1, height: "100%" }}>
              <Grid item xs style={{ marginTop: "20px" }}>
                <RoyaltyStatement />
              </Grid>
            </Grid>
          )}

          {initialTab && (
            <RelatorioAgenda primeiroDia={primeiroDia} date={date} />
          )}

          {tab === "clientes" && <CustomersReport />}

          {tab === "pacotes" && <PackagesReport />}

          {tab === "disparos" && <DispatchReport />}

          {tab === "minhas-exportacoes" && <Downloads setValue={setTap} />}

          {tab === "pets" && <PetsReport />}

          {tab === "notas-fiscais" && (
            <RelatorioNotas primeiroDia={primeiroDia} date={date} link={link} />
          )}

          {tab === "compras" && (
            <Grid container spacing={3} style={{ flex: 1, height: "100%" }}>
              <Grid item xs style={{ marginTop: "20px" }}>
                <PurchaseReport />
              </Grid>
            </Grid>
          )}
        </motion.div>
      </BasePage>
      {/* <Relatorio /> */}
    </ReportProvider>
  )
}

export default RelatorioPage
